import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import { DocumentReferenceResponse, GetProjectResponse } from "api/generatedApi";
import { NoteField } from "shared/editors/note-field";
import { useScreenSize } from "shared/use-screen-size";
import { Divider } from "@mui/material";
import { UploadField } from "shared/editors/upload-field";
import { useState } from "react";
import { useProjectRestrictions } from "shared/user-restrictions/use-project-restrictions";
import { useEffect } from "react";

interface Props {
  project: GetProjectResponse;
}

export const ProjectDocumentationContent = ({ project }: Props) => {
  const { t } = useTranslation();
  const { canEditDescription, canDeleteDocument, canDownloadDocument, canUploadDocument } = useProjectRestrictions(project);
  const { screenSize } = useScreenSize();
  const [documents, setDocuments] = useState<DocumentReferenceResponse[]>([]);

  useEffect(() => {
    setDocuments(project.documents || []);
  }, [project.documents]);

  return (
    <Box>
      <NoteField
        minHeight="150px"
        addTopPadding={true}
        disableButton={true}
        disableEdit={true}
        value={project.description}
        canEditNote={canEditDescription()}
        screenSize={screenSize}
        noContentText={t("dashboard.projectInfo.documentation.noContentTextDescription")}
        showMoreLabel={t("dashboard.projectInfo.documentation.showMoreTitle")}
        textSize="14px"
      />

      <Divider sx={{ my: 1 }} />
      <UploadField
        screenSize={screenSize}
        canUploadDocument={canUploadDocument}
        canDeleteDocument={canDeleteDocument}
        allowDownloads={canDownloadDocument()}
        documents={documents}
        noContentText={t("dashboard.projectInfo.documentation.noContentTextUpload")}
        disabled={true}
      />
    </Box>
  );
};
